import EventBus from '@/util/bus'
import { EventBusKey } from '@/util/bus'
import { onBeforeUnmount, onMounted } from 'vue'

/** 存储windows事件的注册信息 */
const windowEventRegistry = new Map<
  keyof WindowEventMap,
  WeakMap<(...args: any) => any, boolean>
>()

/**
 * 监听window事件 在页面销毁时自动移除事件且不会监听同一个事件
 * @param event 事件名
 * @param handler 事件处理函数
 * @param options 事件选项
 */
export function useWindowEvent<K extends keyof WindowEventMap>(
  event: K,
  handler: (this: Window, ev: WindowEventMap[K]) => any,
  options?: boolean | AddEventListenerOptions
) {
  onMounted(() => {
    const handlerMap = windowEventRegistry.get(event) || new WeakMap()
    windowEventRegistry.set(event, handlerMap)
    if (!handlerMap.has(handler)) {
      window.addEventListener(event, handler, options)
      handlerMap.set(handler, true)
    }
  })
  onBeforeUnmount(() => {
    const handlerMap = windowEventRegistry.get(event)
    if (handlerMap?.has(handler)) {
      window.removeEventListener(event, handler, options)
      handlerMap.delete(handler)
    }
  })
}

/** 存储事件总线的注册信息 */
const eventBusMap = new Map<
  keyof typeof EventBusKey,
  WeakMap<(...args: any) => any, boolean>
>()
/**
 * 监听事件总线事件 在页面销毁时自动移除事件且不会监听同一个事件
 * @param event 事件名
 * @param handler 事件处理函数
 */
export function useEventBus(
  event: keyof typeof EventBusKey,
  handler: (...args: any[]) => void
) {
  onMounted(() => {
    const handlerMap = eventBusMap.get(event) || new WeakMap()
    eventBusMap.set(event, handlerMap)
    if (!handlerMap.has(handler)) {
      EventBus.$on(event, handler)
      handlerMap.set(handler, true)
    }
  })
  onBeforeUnmount(() => {
    const handlerMap = eventBusMap.get(event)
    if (handlerMap?.has(handler)) {
      EventBus.$off(event, handler)
      handlerMap.delete(handler)
    }
  })
}
